import { createContext, useContext } from "react";

export const StaffingPermissionsContext = createContext(null);

export const useStaffingPermissionsContext = () =>
  useContext(StaffingPermissionsContext);
